
import { computed, defineComponent, ref } from 'vue'
import {
    BillingTemplatesListModel,
    useBillingTemplateModule
} from '@/modules/billing-templates'

export default defineComponent({
    name: 'agreement-form-field-billing-template-id',
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: String
        },
        organizationId: {
            type: String,
            required: true
        }
    },
    async setup (props) {
        const { billingTemplatesList, getBillingTemplatesList } = useBillingTemplateModule()

        await getBillingTemplatesList(props.organizationId)

        const billingTemplatesOptions = computed(() => {
            return billingTemplatesList.value.map((billingTemplate: BillingTemplatesListModel) => {
                return {
                    value: billingTemplate.billingTemplateId,
                    label: billingTemplate.templateName
                }
            })
        })

        const filteredOptions = ref(billingTemplatesOptions.value)
        const filterFn = (val: string, update: (arg: () => void) => void) => {
            update(() => {
                const needle = val.toLowerCase()
                filteredOptions.value = billingTemplatesOptions.value.filter(v => v.label.toLowerCase().indexOf(needle) > -1)
            })
        }
        return {
            filteredOptions,
            filterFn
        }
    }
})
